import termsESRP from '../markdown/vouchers/minecraft/termsES_RP.md?raw'
import termsTicketboxESRP from '../markdown/vouchers/ticketbox/termsES_RP.md?raw'
import termsPaddockESAR from '../markdown/vouchers/paddock/variants/termsES_AR.md?raw'

export default {
  common: {
    MOP: 'Pedí y Retirá',
  },
  sidebar: {
    title: {
      normal: 'Disfrutá de la',
      bold: 'mejor experiencia',
    },
  },
  profile: {
    subSections: {
      mySavedAddresses: {
        empty: 'Acá podés ver tus direcciones guardadas',
        addNew: {
          subtitle: 'Encontrá una nueva dirección',
        },
        delete: {
          title: '¿Seguro que querés eliminar esta dirección?',
        },
        toast: {
          limitReached:
            'Alcanzaste el límite de direcciones guardadas. Eliminá una para agregar otra',
        },
      },
    },
  },
  productDetail: {
    customization: {
      chooseOne: 'Elegí uno ',
    },
  },
  checkout: {
    paymentResult: {
      freeOrder: {
        success: {
          title: '¡Pedido exitoso!',
          actions: {
            accept: 'Volver a la home',
          },
        },
      },
    },
  },
  pickupMethods: {
    areaSelection: {
      areas: {
        MOP: {
          step: {
            title: '¿Cómo preferís tu pedido?',
            subtitle: 'Elegí la opción que desees para que podamos prepararlo',
          },
          counterSelection: {
            counters: {
              title: '¿En qué mostrador querés retirar tu pedido?',
              subtitle: 'Elegí el mostrador que prefieras para retirar tu pedido en el restaurante',
            },
          },
        },
      },
    },
  },
  errors: {
    toast: {
      generic: 'Hubo un problema. Por favor, intentalo de nuevo más tarde',
    },
    alerts: {
      noCoverage: {
        title: 'McDelivery no está disponible ahora',
        body: 'Mientras tanto, podés hacer un pedido y retirarlo en el restaurante más cercano con Pedí y Retirá',
        accept: 'Pedí y Retirá',
        cancel: 'Intentar más tarde',
      },
      noRiders: {
        title: 'Nuestros repartidores están ocupados',
        body: 'Podés intentar más tarde o hacer un pedido y retirarlo con Pedí y Retirá',
        accept: 'Pedí y Retirá',
        cancel: 'Intentar más tarde',
      },
      areaNotFound: {
        title: 'El restaurante no está disponible para los productos seleccionados',
        body: 'Podés elegir otro restaurante o volver a tu pedido y cambiar los productos',
        accept: 'Volver a mi pedido',
        cancel: 'Cambiar restaurante',
      },
      productNotAvailable: {
        title: '¡La promoción ya finalizó!',
        body: 'Cambiá los productos de tu pedido para continuar con la compra',
        accept: 'Volver a mi pedido',
        cancel: '',
      },
      promotionNotFound: {
        title: '¡La promoción ya finalizó!',
        body: 'Cambiá los productos de tu pedido para continuar con la compra',
        accept: 'Volver a mi pedido',
        cancel: '',
      },
      limitPriceOrder: {
        body: 'Superaste el valor máximo de {value}. Por favor, revisá los productos del carrito',
        accept: 'Volver a mi pedido',
        cancel: '',
      },
      platformNotValidForPromo: {
        title: 'Esta promoción no es compatible',
        body: 'Por favor, seleccioná otro método de pago para completar la compra',
        accept: 'Elegir otro método de pago',
        cancel: '',
      },
      restaurantNotLoyalty: {
        title: 'Este restaurante no participa de {value}',
        body: 'Para continuar, cambiá los productos de tu pedido o elegí otro restaurante. Si lo hacés, se vaciará tu carrito',
        accept: 'Volver a mi pedido',
        cancel: 'Cambiar restaurante',
      },
      limitedPromoProduct: {
        title: 'Tu pedido ya incluye productos con descuento',
        body: '¿Querés mantener los descuentos actuales o aplicar el nuevo código?',
        accept: 'Mantener descuentos',
        cancel: 'Aplicar nuevo código',
      },
      employeeDiscount: {
        title: 'Tu pedido ya tiene descuentos aplicados',
        body: '¿Querés reemplazar la promoción o agregar el producto sin descuento?',
        accept: 'Agregar sin descuento',
        cancel: 'Reemplazar promoción',
      },
      pickup_serviceNumberEmpty: {
        body: 'Tuvimos un problema al cargar el número que ingresaste. Por favor, intentalo de nuevo',
      },
      pickup_anyPickupAreaForThisOrderIsAvailable: {
        body: 'Podés cancelar el pedido para obtener un reembolso y elegir otra opción ¡Te pedimos disculpas!',
      },
      anyPickupAreaForThisOrderIsAvailable: {
        body: 'Podés cancelar el pedido para obtener un reembolso y elegir otra opción ¡Te pedimos disculpas!',
      },
      pickup_orderPickupNotAvailable: {
        body: 'Podés cancelar el pedido para obtener un reembolso y elegir otra opción ¡Te pedimos disculpas!',
      },
      pickup_areaNotAvailable: {
        body: 'Podés cancelar el pedido para obtener un reembolso y elegir otra opción ¡Te pedimos disculpas!',
      },
      cumulativePromotionsNotAllowed: {
        title: 'Tu pedido ya tiene descuentos aplicados',
        body: '¿Querés reemplazar la promoción o agregar el producto sin descuento?',
        accept: 'Agregar sin descuento',
        cancel: 'Reemplazar promoción',
      },
      autoApplicablePromotionNotAllowed: {
        title: 'Tu pedido ya incluye productos con descuento',
        body: '¿Querés mantener los descuentos actuales o aplicar el nuevo código?',
        accept: 'Mantener descuentos',
        cancel: 'Aplicar nuevo código',
      },
      pickup_counterNotAvailable: {
        body: 'El mostrador seleccionado no está disponible en este momento. Elegí otra opción para retirar tu pedido',
      },
      antifraudTemporalBlock: {
        body: 'No pudimos completar el pedido. Por favor, revisá los datos de tu tarjeta y volvé a intentarlo en otro momento',
      },
      cartEmpty: {
        body: 'Elegí tus productos favoritos y empezá a disfrutar',
      },
      fiscalFieldsRequired: {
        body: 'Por favor, comprobá los datos de tu factura y volvé a intentarlo',
      },
      addressRequired: {
        body: 'Tuvimos un problema para completar tu pedido. Por favor, volvé a intentarlo',
      },
      countryNotValid: {
        body: 'Tuvimos un problema para completar tu pedido. Por favor, intentalo de nuevo',
      },
      orderGeneric: {
        body: 'Tuvimos un problema para completar tu pedido. Por favor, intentalo de nuevo',
      },
    },
  },
  selectRestaurant: {
    DLV: {
      confirmAddress: 'Confirmá tu dirección',
      favorite: {
        formTitle: '¿Cómo querés guardar esta dirección?',
        fields: {
          alias: {
            label: 'Elegí un nombre para esta dirección',
          },
        },
      },
    },
  },
  alertDialog: {
    mcDeliveryError: {
      body: 'Mientras tanto, podés hacer un pedido y retirarlo en el restaurante más cercano con @:common.MOP',
    },
  },
  orders: {
    delivery: {
      description: 'Informá el código al repartidor únicamente al recibir tu pedido',
    },
    vouchers: {
      subtitle: 'Usalo en tu próxima compra dentro de la App',
    },
    ongoingSteps: {
      pending: {
        subtitle: 'Completá el pago para iniciar la preparación',
      },
      ready_for_prep: {
        subtitle: 'Indicá cómo lo querés recibir',
      },
      payment_pending_counter: {
        title: 'Pagá en el mostrador',
        subtitle: 'Anunciate con el número que te indicamos',
      },
      event_date: {
        DLV: {
          subtitle: 'El {mcdiaDateFrom} confirmá que querés recibirlo',
        },
      },
      inform_aut_speaker: {
        title: 'Anunciate en el parlante',
        subtitle: 'Informá el número que te indicamos',
      },
      delivering: {
        subtitle: '¡Preparate para recibirlo!',
      },
      delivered: {
        subtitle: 'Contanos cómo fue la experiencia',
      },
    },
    areas: {
      subtitle: {
        mopDualPoint: 'Retirá el pedido cuando veas tu número en pantalla',
        mop: 'Anunciate con tu número',
        aut: 'Compartí este código para que empecemos a preparar tu pedido',
      },
    },
    messages: {
      yappy:
        'Si tenés dudas sobre tu pedido realizado con Yappy, contactanos a través de nuestro chat',
      flexCancelledReason: {
        type: {
          FLEX_CANCELLED_REFUND:
            'Ocurrió un problema pero, ¡no te preocupes! Recibirás el reembolso en {min} o {max} días hábiles',
        },
      },
    },
    toast: {
      orderUnappliedProducts:
        'La promoción fue añadida, pero no aplica a los productos de tu pedido',
    },
  },
  restaurantTooltipAlert: {
    farFromRestaurantWithOrder: 'Notamos que estás lejos del restaurante donde hiciste el pedido',
    farFromRestaurantWithoutOrder:
      'Notamos que estás lejos del restaurante donde hiciste el pedido. Podés cambiarlo presionando sobre la dirección',
  },
  enrollment: {
    Document: {
      warning: {
        title: 'Documento ya registrado',
        body: 'Este número de documento ya está registrado para el email {email}. Para más información, ponete en contacto con ',
      },
      modal: {
        title: 'Este número ya fue registrado con el mail [{email}]',
        subtitle: {
          text: '¿Qué podés hacer?',
          option1: 'Ingresá con ese mail si tenés acceso',
          option2: 'Recuperá tu contraseña si no la recordás',
          option3: 'Contactanos si ya no tenés acceso a ese mail',
        },
        loginWithThisEmail: 'Ingresar con este mail',
      },
    },
  },
  vouchers: {
    minecraft: {
      title: 'Tenés disponibles',
      description: 'Podés obtener un código Minecraft si tenés los puntos necesarios',
      redeemCoupon: {
        title: '¿Querés canjear <br/><b>{value} pts.</b> para obtener <br/>un código?',
        accept: 'Quiero obtener un código',
        cancel: 'Ahora no',
      },
      appliedCoupon: {
        title: '¡Felicitaciones! Acabás de obtener tu código Minecraft',
        useCodeInfo: '¿Cómo usar los códigos?',
        codeExpiration: 'Tu código vence el',
        accept: 'Volver',
      },
      codeList: {
        title: 'Ver mis códigos obtenidos',
        titleMinecraft: 'Mis códigos minecraft',
        description: 'Códigos',
        code: 'Código',
        expiration: 'Caducidad',
      },
      notification: {
        title: 'Solo se permite activar un código por cuenta Minecraft',
        description:
          "Canjeá tus puntos desde el { startDate } al { endDate } o hasta agotar el stock de { stock } unidades. El código activa 25 complementos (Add-ons) de McDonald's en Minecraft: Bedrock Edition { linkTerms }",
      },
      errors: {
        generic: 'Algo no salió como esperábamos. Intentalo de nuevo más tarde',
        maximumPurchasesExceeded: 'Superaste el número máximo de compras de códigos Minecraft',
        noPointsAvailable: {
          title:
            'No tenés los puntos necesarios para obtener un código. Necesitás { value } pts. para conseguirlo',
          description: 'Podés obtener un código Minecraft si tenés los puntos necesarios',
        },
      },
      emptyVoucherList: {
        description:
          'Parece que no participaste de la promoción, por eso no podemos mostrar ningún código',
        accept: 'Volver',
      },
    },
    ticketbox: {
      title: 'Tenés disponibles',
      description: 'Activá el código y seguí las instrucciones para obtener tu entrada de cine',
      redeemCoupon: {
        title: '¿Querés canjear <br/><b>{value} pts.</b> para obtener un código <br/> McDonald´s?',
        accept: 'Quiero obtener un código',
        cancel: 'Ahora no',
      },
      appliedCoupon: {
        title: '¡Felicitaciones! Acabás de obtener un código McDonald´s',
        useCodeInfo: '¿Cómo activo el código?',
        codeExpiration: 'Tu código McDonald´s vence el',
        accept: 'Volver',
      },
      codeList: {
        title: 'Ver mis códigos obtenidos',
        titleMinecraft: 'Mis códigos',
        description: 'Códigos',
        code: 'Código',
        expiration: 'Caducidad',
      },
      notification: {
        title:
          'Podés activar el código McDonald´s en TicketBox y seguir las instrucciones para obtener tu entrada a la función de cine 2D',
        description:
          'Canje de puntos válido a través de la App de <br/> McDonald´s Argentina desde el { startDate } hasta el { endDate } o hasta agotar el stock de { stock } códigos McDonald´s. { linkTerms }',
        acceptTermsNotice: {
          title: 'Al realizar el canje, aceptas las',
          link: {
            label: 'Bases y Condiciones',
            url: 'https://www.mcdonalds.com.ar/terminos-y-condiciones-mimcine',
          },
        },
      },
      errors: {
        generic: 'Algo no salió como esperábamos. Intentalo de nuevo más tarde',
        maximumPurchasesExceeded: 'Superaste el número máximo de compras de códigos de cine',
        noPointsAvailable: {
          title: '¡Estás cerca de tu código McDonald´s!',
          description: ' Necesitás 1500 puntos para obtenerlo ¡Seguí sumando!',
        },
      },
      emptyVoucherList: {
        description:
          'Parece que no participaste de la promoción, por eso no podemos mostrar ningún código',
        accept: 'Volver',
      },
    },
    paddockf1: {
      title: 'Tenés disponibles',
      description:
        'Si hacés clic en "Volver", vas a poder canjear más chances si contás con los puntos suficientes',
      redeemCoupon: {
        title: '¿Querés canjear <br/><b>{value} pts.</b> para obtener una chance?',
        accept: 'Quiero obtener una chance',
        cancel: 'Ahora no',
      },
      appliedCoupon: {
        title: '¡Felicitaciones! Acabás de obtener una chance para participar del sorteo.',
        description:
          'El sorteo se realizará entre todos los códigos canjeados. Tu chance está asociada al código a continuación',
        useCodeInfo: '¿Tenés dudas?',
        codeExpiration: 'El sorteo será realizado el',
        accept: 'Volver',
      },
      codeList: {
        title: 'Ver mis códigos obtenidos',
        titleMinecraft: 'Mis códigos',
        description: 'Códigos',
        code: 'Código',
        expiration: 'Caducidad',
      },
      notification: {
        title:
          '¡Sumá una chance para participar del sorteo para vivir el exclusivo Paddock Club™ Brasil en la carrera Formula 1 São Paulo Grand Prix 2025, del 7 al 9 de noviembre, para el ganador y un acompañante!',
        description:
          'Promoción válida desde el { startDate } hasta el { endDate } inclusive, únicamente mediante la aplicación McDonald’s Argentina. Por cada { stock } puntos canjea 1 chance para participar del sorteo. Consulta las { linkTerms }',
        acceptTermsNotice: {
          title:
            'No participan residentes de Mendoza, Neuquén, Salta, Jujuy, Tierra del Fuego, Chubut y Rio Negro. Al realizar el canje, estás aceptando las',
          link: {
            label: 'Bases y Condiciones.',
            url: 'https://www.mcdonalds.com.ar/bases-y-condiciones-paddock2025',
          },
        },
      },
      errors: {
        generic: 'Algo no salió como esperábamos. Intentalo de nuevo más tarde',
        maximumPurchasesExceeded: 'Superaste el número máximo de chances',
        noPointsAvailable: {
          title: '¡Estás cerca de obtener una chance!',
          description: 'Necesitás 100 puntos para obtenerlo ¡Seguí sumando!',
        },
      },
      emptyVoucherList: {
        description:
          'Parece que no participaste de la promoción, por eso no podemos mostrar ningún código',
        accept: 'Volver',
      },
    },
    trophytour: {
      title: 'Tenés disponibles',
      description:
        'Accede al sitio web de Coca-Cola, loguéate para obtener tu entrada y elegir el día y el horario disponibles.',
      redeemCoupon: {
        title: '¿Querés canjear <br/><b>{value} pts.</b> para obtener un código?',
        accept: 'Quiero obtener un código',
        cancel: 'Ahora no',
      },
      appliedCoupon: {
        title: '¡Felicitaciones! Acabas de obtener un código',
        description:
          'Accede al sitio web de Coca-Cola, loguéate para obtener tu entrada y elegir el día y el horario disponibles.',
        useCodeInfo: '¿Cómo activar mi código?',
        codeExpiration: 'Tu código vence el',
        accept: 'Volver',
        termsLinks:
          'https://www.coca-cola.com/ar/es/offerings/copa-mundial-de-la-fifa-2026/trophy-tour-partner',
      },
      codeList: {
        title: 'Ver mis códigos obtenidos',
        titleMinecraft: 'Mis códigos',
        description: 'Códigos',
        code: 'Código',
        expiration: 'Caducidad',
      },
      notification: {
        title:
          'Podrás activar tu código en el sitio web de Coca-Cola para obtener una entrada al evento FIFA World Cup Trophy Tour by Coca-Cola, que se realizará en Av. Sarmiento 2704, C1425 Ciudad Autónoma de Buenos Aires, Argentina el 19 y 20 de febrero de 2026.',
        description:
          'Canje de puntos válido a través de la App McDonald’s Argentina desde el { startDate } al { endDate } o hasta agotar el stock de { stock } códigos.',
        acceptTermsNotice: {
          title:
            'Al activar el código, podrás seleccionar solo un día y un horario disponible en el sitio web. Al realizar el canje, aceptás las',
          link: {
            label: 'Bases y Condiciones.',
            url: 'https://cloud.news.mcdonalds.com.ar/TyCs_Trophy_Tour',
          },
        },
      },
      errors: {
        generic: 'Algo no salió como esperábamos. Intentalo de nuevo más tarde',
        maximumPurchasesExceeded: 'Superaste el número máximo de compras de códigos',
        noPointsAvailable: {
          title: '¡Estás cerca de obtener un código!',
          description: 'Necesitás 750 puntos para obtenerlo ¡Sigue sumando!',
        },
      },
      emptyVoucherList: {
        description:
          'Parece que no participaste de la promoción, por eso no podemos mostrar ningún código',
        accept: 'Volver',
      },
    },
  },
  offers: {
    title: '¡Accedé a este cupón descargando nuestra app!',
    description: 'Aprovechá beneficios únicos y ofertas todos los días desde tu celular',
  },
  markdown: {
    vouchers: {
      minecraft: {
        terms: termsESRP,
      },
      ticketbox: {
        terms: termsTicketboxESRP,
      },
      paddockf1: {
        terms: termsPaddockESAR,
      },
    },
  },
  loyalty: {
    title: 'Sumá puntos con { programName } y canjealos por recompensas. <br/> ¡Descargate la app!',
    description: 'Ahorrá con puntos, aprovechá promos y cupones que van con vos',
    link: 'Saber más sobre { programName }',
    name: 'Mi McDonald’s',
  },
  mandatoryTerms: {
    title: 'Aceptá los Términos y Condiciones para continuar',
    subtitle:
      'Necesitás leer y aceptar los Términos y Condiciones para seguir usando nuestras plataformas',
  },
  shoppingCart: {
    feesInfo: {
      smallOrderFee: {
        name: 'Tarifa por pedido pequeño',
        info: 'Se aplica en pedidos con un subtotal menor a un monto determinado. Podés evitarla sumando más productos al carrito.',
      },
    },
  },
  promotions: {
    deepLinks: {
      seeCartProducts: 'Para ver tu descuento entra en el carrito',
      addCartProducts: 'Para disfrutar del descuento, agrega productos al carrito',
    },
  },
  birthdayLanding: {
    title: '¡Reservá tu cumpleaños en McDonald’s directo desde la App!',
    subtitle:
      'Celebrar su día nunca fue tan fácil: descargá la App y reservá un cumple inolvidable en pocos pasos.',
  },
}
